module.exports = __webpack_public_path__ + "static/media/serversInactive.adb31ca2.svg";